"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedalliaForm = void 0;
const rxjs_1 = require("rxjs");
// MedalliaForm relies on the Medallia embed.js bootstrap code loaded separately
// and interacts with the Medallia SDK using window.KAMPYLE_ONSITE_SDK
// https://docs.medallia.com/en/medallia-digital/medallia-digital-web/administration-guide/targeting-surveys/code-based-triggers/using-javascript-to-target-surveys
class MedalliaForm {
    /**
     * Constructs a new MedalliaForm for the given form ID.
     * @param formId the Medallia form ID to load
     */
    constructor(formId) {
        this.formId = formId;
        this.formLoadedSubject = new rxjs_1.BehaviorSubject(false);
        this.waitForMedalliaSdkAndLoadForm();
    }
    waitForMedalliaSdkAndLoadForm() {
        if (window.KAMPYLE_ONSITE_SDK) {
            this.loadForm();
        }
        else {
            window.addEventListener('neb_OnsiteLoaded', () => this.loadForm());
        }
    }
    loadForm() {
        const formLoaded = window.KAMPYLE_ONSITE_SDK.loadForm(this.formId);
        this.formLoadedSubject.next(formLoaded);
        if (!formLoaded) {
            throw new Error('failed to load Medallia form ' + this.formId);
        }
    }
    /**
     * Shows the Medallia form, if loaded.
     */
    showForm() {
        if (this.formLoadedSubject.getValue()) {
            window.KAMPYLE_ONSITE_SDK.showForm(this.formId);
        }
        else {
            throw new Error('cannot show unloaded Medallia form');
        }
    }
    static initializeMedalliaScripts(medalliaConfig) {
        if (!medalliaConfig || !medalliaConfig.scriptSrcUrl) {
            throw new Error("Missing Medallia configuration to initialize script");
        }
        let medalliaScriptElement = document.createElement("script");
        medalliaScriptElement.id = "medallia";
        medalliaScriptElement.type = "text/javascript";
        medalliaScriptElement.src = medalliaConfig.scriptSrcUrl;
        medalliaScriptElement.async = true;
        document.body.appendChild(medalliaScriptElement);
    }
}
exports.MedalliaForm = MedalliaForm;
//# sourceMappingURL=mediallia-form.js.map